import { PromoCampaignPage } from '@/pages/promo-campaign/promo-campaign'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/p/promo/create')({
	component: PromoCampaignPage,
})
